import { useState, useEffect } from 'react';
import user from "../../assets/user2.png"
import google from "../../assets/google.png";
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';

const NewReview = ({layout,testimonial,name,star,profile,highlight,colorTheme}) =>{
    const [starsToShow, setStarsToShow] = useState(0);
    const [displayText, setDisplayText] = useState('');
    const [isValid, setIsValid] = useState(true);
    const [fade,setFade]=useState(false);
    const [words, setWords] = useState([]);
    const [commonWords, setCommonWords] = useState([]);

    useEffect(() => {
      const testimonialWords = testimonial && testimonial.trim().split(/\s+/);
      setWords(testimonialWords);
    
      // Flatten the array of strings into a single array of words
      const highlightWords = highlight && highlight.flatMap(str => str.split(/\s+/));
      
      const common = testimonialWords && testimonialWords.filter(word => highlightWords?.includes(word));
      setCommonWords(common);
    }, [testimonial, highlight]);   
  
    const renderHighlightedTestimonial = () => {
      return words&&words.map((word, index) => {
        if (commonWords.includes(word)) {
          return(
            <>
            {/* <span>&nbsp;</span> */}
            <span key={index} className="highlighted-text">{word}</span>
            <span>&nbsp;</span>
            </>
          ) ;
        } else {
          return <span key={index}>{word} </span>;
        }
      });
    }

  useEffect(()=>{
    setTimeout(() => {
      setFade(true)
    }, 9000);
  })

  const handleImageError = () => {
    setIsValid(false);
  };
   
    useEffect(() => {
      let i = 0;
      const interval = setInterval(() => {
        if (testimonial &&i < testimonial.length) {
          const currentChar = testimonial.charAt(i);
          setDisplayText(prevText => prevText + currentChar);
          i++;
        } else {
          clearInterval(interval);
          startStarAnimation();
        }
      }, 10);
    
      return () => clearInterval(interval);
    }, [testimonial]);
   
    const startStarAnimation = () => {
      const interval = setInterval(() => {
        setStarsToShow(prevStars => {
          if (prevStars < 5) {
            return prevStars + 1;
          } else {
            clearInterval(interval);
            return prevStars;
          }
        });
      }, 300);
    };

return(
  layout === "Landscape"?(
  
     <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(5px)', // Blur effect
            zIndex: 1000, // Ensure it's above other content
          }}
        >
           <div>
      <img onError={handleImageError}
        src={profile&&isValid?profile:user}
        width={140}
        className={`profile-img ${fade ? 'fade-out' : ''}`}
        style={{
          position: "absolute",
          zIndex: "9",
          top: "14vh",
          left: "31vw",
          border: "3px solid white",
          borderRadius: "50%",
          transition: "transform 1s ease-in-out"
        }}
      />
      <div
        className={`content-box ${fade ? 'close-book' : ''}`}
        style={{
          position: "absolute",
          left: "34vw",
          top: "24vh",
          background: "white",
          borderRadius: "30px",
          maxHeight: "65vh",
          width: "30vw",
          padding: "30px",
        }}
      >
         <img src={google} width={35} style={{ position:"absolute",top:"15px",right:"15px" }} />
         <p style={{fontWeight:"400",fontSize:"1.7vw",margin:"0 0 1vh 0",color:colorTheme?colorTheme:"#703484"}}>New review alert!</p>
         <p style={{color:colorTheme?colorTheme:"#703484",fontWeight:"100",fontSize:"2.2vw",margin:"0 0 2vh 0",fontStyle:"italic"}} className="animated-title">{name}</p>
       <div style={{display:"flex",gap:"1.5vw",justifyContent:"center"}}>
       {Array(5).fill().map((_, i) => {
    if (i < Math.floor(star)) {
      return (
        <div key={i}>
          <FaStar color="gold" size={25}   className={i < starsToShow ? 'star animated' : 'star'}/>
        </div>
      );
    } else if (i === Math.floor(star)) {
      return (
        <div key={i}>
          <FaStarHalfAlt color="gold" size={25}   className={i < starsToShow ? 'star animated' : 'star'}/>
        </div>
      );
    } else {
      return (
        <div key={i}>
          <FaRegStar color="gold" size={25}   className={i < starsToShow ? 'star animated' : 'star'}/>
        </div>
      );
    }
  })}
        </div>
       
        <p style={{color:"black",fontWeight:"400",fontSize:"1.7vw"}} className="animated-first">{renderHighlightedTestimonial()}</p>
       
      </div>
      {/* <div
        className="content-box"
        style={{
          position: "absolute",
          left: "33vw",
          top: "51vh",
          background: "#313131",
          borderRadius: "0 0 30px 30px",
          maxHeight: "4vh",
          width: "30vw",
          padding: "0 17px",
          color:"white",
          fontWeight:"100",
          fontStyle:"italic"
        }}
      >Rhea Harsh</div> */}
      </div>
        </div>
  
  ):(
    <div 
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backdropFilter: 'blur(5px)', // Blur effect
      zIndex: 1000, // Ensure it's above other content
    }}
  >
    <div>
      <img onError={handleImageError}
        src={profile&&isValid?profile:user}
        width={140}
        className={`profile-img ${fade ? 'fade-out' : ''}`}
        style={{
          position: "absolute",
          zIndex: "9",
          top: "23vh",
          left: "16vw",
          border: "3px solid white",
          borderRadius: "50%",
          transition: "transform 1s ease-in-out",
          width:"15vw"
        }}
      />
      <div
        className={`content-box ${fade ? 'close-book' : ''}`}
        style={{
          position: "absolute",
          left: "22vw",
          top: "28vh",
          background: "white",
          borderRadius: "30px",
          maxHeight: "65vh",
          width: "50vw",
          padding: "30px",
        }}
      >
         <img src={google} width={35} style={{ position:"absolute",top:"15px",right:"15px" }} />
         <p style={{color:colorTheme?colorTheme:"#703484",fontWeight:"100",fontSize:"5vw",margin:"0 0 2vh 0",fontStyle:"italic"}} className="animated-title">{name}</p>
       <div style={{display:"flex",gap:"1.5vw",justifyContent:"center"}}>
       {Array(5).fill().map((_, i) => {
    if (i < Math.floor(star)) {
      return (
        <div key={i}>
          <FaStar color="gold" size={25}   className={i < starsToShow ? 'star animated' : 'star'}/>
        </div>
      );
    } else if (i === Math.floor(star)) {
      return (
        <div key={i}>
          <FaStarHalfAlt color="gold" size={25}   className={i < starsToShow ? 'star animated' : 'star'}/>
        </div>
      );
    } else {
      return (
        <div key={i}>
          <FaRegStar color="gold" size={25}   className={i < starsToShow ? 'star animated' : 'star'}/>
        </div>
      );
    }
  })}
        </div>
       
        <p style={{color:"black",fontWeight:"400",fontSize:"3vw"}} className="animated-first">{renderHighlightedTestimonial()}</p>
       
      </div>
      {/* <div
        className="content-box"
        style={{
          position: "absolute",
          left: "33vw",
          top: "51vh",
          background: "#313131",
          borderRadius: "0 0 30px 30px",
          maxHeight: "4vh",
          width: "30vw",
          padding: "0 17px",
          color:"white",
          fontWeight:"100",
          fontStyle:"italic"
        }}
      >Rhea Harsh</div> */}
      </div>
      </div>
  )
)
}

export default NewReview